import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { Badge, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface PageTabItem {
  label: string;
  route: RoutesEnum;
  /** If true, label is used as-is instead of being passed through t() */
  rawLabel?: boolean;
  badgeCount?: number;
}
type PageTabNavigationProps = {
  pageTabs: PageTabItem[];
};

const useRouteMatch = (patterns: readonly string[]) => {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
};

const PageTabNavigation = (props: PageTabNavigationProps) => {
  const { pageTabs } = props;
  const { t } = useTranslation();
  const routeMatch = useRouteMatch(pageTabs.map((x) => x.route)); // Order is important here, read documentation on MUI
  const currentTab = routeMatch?.pattern?.path;

  return (
    <>
      <Tabs value={currentTab}>
        {pageTabs.map((item) => {
          const labelText = item.rawLabel ? item.label : t(item.label);
          return (
            <Tab
              key={item.route}
              label={
                item.badgeCount ? (
                  <Badge
                    badgeContent={item.badgeCount}
                    color='error'
                    sx={{
                      '& .MuiBadge-badge': {
                        top: 0,
                        right: -18,
                        transform: 'translateY(-50%) scale(1)',
                        minWidth: 16,
                        height: 16,
                        fontSize: '0.65rem',
                        padding: '0 4px',
                      },
                    }}
                  >
                    {labelText}
                  </Badge>
                ) : (
                  labelText
                )
              }
              sx={item.badgeCount ? { pr: 4 } : undefined}
              value={item.route}
              to={item.route}
              component={Link as any}
            />
          );
        })}
      </Tabs>
      <Divider />
    </>
  );
};
export default PageTabNavigation;
